<template>
  <div class="contentBox">
    <!-- 表格数据 -->
    <div class="tableBox">
      <!-- 预兑材料管理-->
      <div class="innovationVoucher">
        <img src="@/assets/images/table-tab.png" width="8px" height="23px" />
        <span>预兑材料管理</span>
      </div>
      <!-- Tabs标签组件 -->
      <Tabs :tabs="tabsList" @tab-click="tabClick">
        <template v-slot:button>
          <div v-if="rightbutton">
            <span style="font-weight: bold; text-decoration: underline; cursor: pointer" @click="download('4f16931a877e4734b9e968e1931fc492')">预兑材料操作手册</span>
            <span style="font-weight: bold; text-decoration: underline; cursor: pointer; color: red; margin: 0 15px 0 15px" @click="download('52bf47d04f9544d1bccda9ddf0fa109b')"
              >预兑付统计表模板下载</span
            >
            <el-button size="mini" type="primary" @click="addexmaterials">新增材料</el-button>
          </div>
          <div v-else style="display: flex; align-items: center; justify-content: center">
            <span style="margin-right: 10px; font-size: 16px">兑付单位</span>
            <el-input v-model="inputValue" placeholder="搜索单位" size="medium" style="width: 200px" @keyup.enter.native="tabClick({ value: '预兑材料明细' })"></el-input>
          </div>
        </template>
        <template v-if="currentUsersData.length">
          <JRtable :table-data="currentUsersData" :selection="false" :index="true" @page-change="changePages" :pageOptions="pageOptions" :column="currentUsersColumns" size="mini" :border="true">
            <template slot="slot_record_tools" slot-scope="data">
              <el-button @click="handleViewRedemptionDetails(data.scope.row)" size="mini" type="danger">删除</el-button>
            </template>
            <template slot="slot_record_tjb" slot-scope="data">
              <el-button type="text" @click="previewFj(data.scope.row.tjbid, '2', data.scope.row.tjbmc)">{{ data.scope.row.tjbmc }}</el-button>
            </template>
            <template slot="slot_record_fj" slot-scope="data">
              <el-button type="text" @click="previewFj(data.scope.row.fjzmid, '1', data.scope.row.fjzmmc)">{{ data.scope.row.fjzmmc }}</el-button>
            </template>
          </JRtable>
        </template>
        <el-empty v-else description="暂无数据"></el-empty>
      </Tabs>
      <!-- 新增预兑材料弹窗表单 -->
      <Dialog :visible.sync="showDialog" width="1000px" title="新增预兑材料" :showBtn="false" @confirm="handleConfirm" @cancel="handleCancelForm" @close="handleCancelForm" :append-to-body="true">
        <template #content>
          <div class="applyform">
            <el-form :model="preexchangeForm" :rules="ruleExchangeForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-card class="box-cards upload-attachments">
                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="服务机构名称：" prop="jgmc" label-width="200px">
                      <el-select v-model="preexchangeForm.jgid" placeholder="请选择对应的服务机构" style="width: 500px" @change="fwjgChange">
                        <el-option v-for="item in options" :key="item.jgid" :label="item.jgmc" :value="item.jgid"> </el-option>
                      </el-select> </el-form-item
                  ></el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="兑付总金额（万元）：" prop="dfjewy" label-width="200px">
                      <el-input v-model="preexchangeForm.dfjewy" style="width: 250px" clearable></el-input> <span class="warnig_text">单位：万元</span>
                    </el-form-item></el-col
                  >
                </el-row>
                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="合同总金额（万元）：" prop="htjewy" label-width="200px">
                      <el-input v-model="preexchangeForm.htjewy" style="width: 250px" clearable></el-input> <span class="warnig_text">单位：万元</span></el-form-item
                    ></el-col
                  >
                </el-row>
                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="附件证明材料：" prop="fjzmid" label-width="200px">
                      <el-upload
                        v-if="preexchangeForm.jgid"
                        :action="upload.action"
                        :name="upload.fileName"
                        :http-request="uploadOk"
                        :on-preview="handlePreview"
                        :on-change="(file, self) => uploadExcel(file, self, '1')"
                        :on-remove="handleRemove"
                        multiple
                        :file-list="fileList"
                        :disabled="lookDisabled"
                        :limit="1"
                      >
                        <span class="upload-icon"><i class="el-icon-upload2"></i>上传</span>
                      </el-upload>
                      <span class="warnig_text">附件包括：服务合同、服务机构确认函等材料、（确认函机构自拟）</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="统计表盖章文件：" prop="tjbid" label-width="200px">
                      <el-upload
                        v-if="preexchangeForm.jgid"
                        :action="upload.action"
                        :name="upload.fileName"
                        :http-request="uploadOk"
                        :on-preview="handlePreview"
                        :on-change="(file, self) => uploadExcel(file, self, '2')"
                        :on-remove="handleRemoveTj"
                        multiple
                        :file-list="fileListTj"
                        :disabled="lookDisabled"
                        :limit="1"
                      >
                        <span class="upload-icon"><i class="el-icon-upload2"></i>上传</span>
                      </el-upload>
                      <span class="warnig_text" style="text-decoration: underline; cursor: pointer" @click="download('52bf47d04f9544d1bccda9ddf0fa109b')">预兑付统计表模板下载</span>
                      <span class="warnig_text">按照模板填写统计表内容后，打印盖章并上传！</span>
                    </el-form-item></el-col
                  >
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="统计表导入：" prop="approval_exchange_amount" label-width="200px">
                      <el-upload
                        :action="upload.action"
                        :name="upload.fileName"
                        :http-request="uploadOk"
                        :on-preview="handlePreview"
                        :on-change="(file, self) => uploadExcel(file, self, '3')"
                        :on-remove="handleRemove"
                        multiple
                        :file-list="fileListDr"
                        :disabled="lookDisabled"
                        :limit="1"
                      >
                        <span class="upload-icon"><i class="el-icon-upload2"></i>上传</span>
                      </el-upload>
                      <span class="warnig_text">上传填写好的统计表Excel。注意：严格 按照统计表模板填写，不要修改表头字段内容！ </span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-card>
            </el-form>
          </div>
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
import JRtable from '@/components/Table'
import Tabs from '@/components/Tabs'
import Dialog from '@/views/enterprise/components/Dialog'
import { getJgList, getMaterialList, getMaterialDetailList, getUploadFjzmFile, getUploadTjbFile, getSaveOrUpdate, getExcelRead, getFactYdclmxDelete, getTabStatistics } from '@/api/mechanism/material'
import { getUuid } from '@/utils'
import { getToken } from '@/utils/cache'
import axios from 'axios'

export default {
  components: {
    JRtable,
    Tabs,
    Dialog
  },
  data() {
    return {
      // 禁用表单
      lookDisabled: false,
      // 表格数据
      currentUsersData: [],
      currentUsersColumns: [
        {
          label: '序号',
          prop: 'id',
          align: 'center',
          width: '300'
        },
        {
          label: '机构名称',
          prop: 'id2',
          align: 'center'
        },
        {
          label: '兑付金额（万元）',
          prop: 'id3',
          align: 'center'
        },
        {
          label: '合同金额（万元）',
          prop: 'id4',
          align: 'center'
        },
        {
          label: '统计表',
          prop: 'id5',
          align: 'center',
          slot: 'slot_record_tjb'
        },
        {
          label: '附件',
          prop: 'id6',
          align: 'center',
          slot: 'slot_record_fj'
        }
      ],
      // 顶部横向tabs切换栏目
      tabsList: [
        {
          id: 0,
          value: '预兑材料',
          isActive: true,
          quantity: 0,
          permission: ['编辑', '查看']
        },
        {
          id: 1,
          value: '预兑材料明细',
          isActive: false,
          quantity: 0,
          permission: ['查看']
        }
      ],
      // 是否显示dialog
      showDialog: false,
      // 预兑材料表单对应的form信息
      preexchangeForm: {
        id: getUuid(), //主键（需要前端生成）'
        jgmc: '', //机构名称
        jgid: '', //机构id
        dfjewy: '', //兑付金额(万元
        htjewy: '', //合同金额(万元
        cjsj: '', //创建时间
        zt: '', //状态（0失效1生效）'
        fjzmid: '', //附件证明id
        tjbid: '' //统计表id
      },
      // 预兑材料申请表 所需的 form 验证规则
      ruleExchangeForm: {
        // 服务机构名称：
        jgmc: [{ required: true, message: '请选择', trigger: 'change' }],
        // 兑付总金额（万元）：
        dfjewy: [{ required: true, message: '请输入', trigger: 'blur' }],
        // 合同总金额（万元）：
        htjewy: [{ required: true, message: '请输入', trigger: 'blur' }],
        // 附件证明材料：
        fjzmid: [{ required: true, message: '请上传', trigger: 'change' }],
        // 统计表导入：
        tjbid: [{ required: true, message: '请上传', trigger: 'change' }]
      },
      // 下拉框选择的数据
      selecteValue: '',
      // 下拉框的数据
      options: [],
      // 输入框数据
      inputValue: '',
      // 右侧展示
      rightbutton: true,
      pageOptions: {
        limit: 10,
        page: 1,
        total: 0
      },

      // 附件上传
      upload: {
        action: '#',
        fileName: 'file'
      },
      fileList: [],
      fileListTj: [],
      fileListDr: []
    }
  },
  mounted() {
    this.getJgList()
    this.tabClick({ value: '预兑材料' })
    this.getTabNum()
  },
  methods: {
    // 获取机构列表
    async getJgList() {
      const result = await getJgList()
      this.options = result.data
    },
    getTabNum() {
      getTabStatistics().then((res) => {
        if (res.code === 200) {
          this.tabsList[0].quantity = res.data.ydclNum
          this.tabsList[1].quantity = res.data.mxNum
        }
      })
    },

    // 删除
    handleViewRedemptionDetails(val) {
      this.$confirm('确认删除该条信息吗？, 是否继续?', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        center: true
      })
        .then(() => {
          const params = {
            uuid: val.uuid
          }
          getFactYdclmxDelete(params).then((res) => {
            if (res.code === 200) {
              this.tabClick({ value: '预兑材料明细' })
              this.$message({
                type: 'success',
                message: '删除成功'
              })
            }
          })
        })
        .catch(() => {})
    },
    // tabs栏目点击切换事件
    async tabClick(item) {
      // 根据点击的tabs栏目，去发起不同的请求，获取不同的数据来渲染dataCards组件
      switch (item.value) {
        case '预兑材料':
          // TODO:根据不同选项卡，请求不同的数据，赋值给  this.itemList  用于传给dataCards组件渲染
          this.rightbutton = true
          const result = await getMaterialList({ ...this.pageOptions })
          this.currentUsersColumns = [
            {
              label: '机构名称',
              prop: 'jgmc',
              align: 'center'
            },
            {
              label: '兑付金额（万元）',
              prop: 'dfjewy',
              align: 'center'
            },
            {
              label: '合同金额（万元）',
              prop: 'htjewy',
              align: 'center'
            },
            {
              label: '统计表',
              prop: 'tjbmc',
              align: 'center',
              slot: 'slot_record_tjb'
            },
            {
              label: '附件',
              prop: 'fjzmmc',
              align: 'center',
              slot: 'slot_record_fj'
            }
          ]
          this.currentUsersData = result.data.records || []
          this.pageOptions.total = result.data.total
          break
        case '预兑材料明细': // 待办事项
          // TODO:根据不同选项卡，请求不同的数据，赋值给  this.itemList  用于传给dataCards组件渲染
          this.rightbutton = false
          this.currentUsersColumns = [
            {
              label: '兑付单位',
              prop: 'zfqymc',
              align: 'center'
            },
            {
              label: '兑付金额（万元）',
              prop: 'dfje',
              align: 'center'
            },
            {
              label: '合同金额（万元）',
              prop: 'htje',
              align: 'center'
            },
            {
              label: '机构名称',
              prop: 'jgmc',
              align: 'center'
            },
            {
              label: '新增时间',
              prop: 'xzsj',
              align: 'center'
            },
            {
              label: '操作',
              prop: 'id7',
              align: 'center',
              slot: 'slot_record_tools'
            }
          ]
          const prams = {
            page: this.pageOptions.page,
            size: this.pageOptions.limit,
            zfqymc: this.inputValue
          }
          const result1 = await getMaterialDetailList(prams)
          this.currentUsersData = result1.data.records || []
          this.pageOptions.total = result1.data.total

          break
      }
    },
    // 翻页
    changePages(page) {
      this.pageOptions.page = page.page
      if (this.rightbutton) {
        this.tabClick({ value: '预兑材料' })
      } else {
        this.tabClick({ value: '预兑材料明细' })
      }
    },
    // 点击新增材料
    addexmaterials() {
      this.showDialog = true
    },
    // 预兑付统计表模板下载
    download(type) {
      window.location.href = process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/system/api/sysFileTemplateManage/downloadTemplate/' + type
    },
    // 获取服务机构id
    fwjgChange(val) {
      const name = this.options.filter((e) => e.jgid === val)[0].jgmc
      if (name) {
        this.preexchangeForm.jgmc = name
      }
    },

    // 附件上传
    uploadExcel(file, fileList, type) {
      // console.log(file, fileList, type)
      const fileTemp = file.raw
      const fileName = file.raw.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      if (fileTemp) {
        if (fileType === 'xlsx' || fileType === 'xls') {
          const formData = new FormData()
          formData.append('file', file.raw)
          formData.append('jgid', this.preexchangeForm.jgid)
          switch (type) {
            case '1':
              getUploadFjzmFile(formData).then((res) => {
                this.preexchangeForm.fjzmid = res.data
                this.fileList.push({
                  name: file.raw.name,
                  fileId: res.data // 假设后端返回的文件地址为 response.url
                })
                this.$message({
                  type: 'success',
                  message: '上传成功'
                })
              })
              break
            case '2':
              getUploadTjbFile(formData).then((res) => {
                this.preexchangeForm.tjbid = res.data
                this.fileListTj.push({
                  name: file.raw.name,
                  fileId: res.data // 假设后端返回的文件地址为 response.url
                })
                this.$message({
                  type: 'success',
                  message: '上传成功'
                })
              })
              break
            case '3':
              formData.append('zbid', this.preexchangeForm.id)
              getExcelRead(formData).then((res) => {
                if (res.code === 200) {
                  this.handleConfirm()
                }
              })
              break
          }
        } else {
          this.$message({
            type: 'warning',
            message: '附件格式错误，请重新上传！'
          })
        }
      } else {
        this.$message({
          type: 'warning',
          message: '请上传附件！'
        })
      }
    },
    // 附件预览
    handlePreview(file) {
      // const params = {
      //   fileId: this.fileList.filter((item) => item.name === file.name)[0] ? this.fileList.filter((item) => item.name === file.name)[0].fileId : ''
      // }
      // const response = await axios.get('/sc/ticketMain/api/factGsxx/previewFile', {
      //   baseURL: process.env.VUE_APP_BASE_API,
      //   params: params,
      //   responseType: 'blob' // 设置响应类型为二进制流
      // })
      // const blob = new Blob([response.data], { type: response.headers['content-type'] })
      // const url = URL.createObjectURL(blob)
      // const link = document.createElement('a')
      // link.href = url
      // link.download = file.name // 下载文件的名称
      // document.body.appendChild(link)
      // link.click()
      // URL.revokeObjectURL(url)
    },
    // 删除附件
    handleRemove(file, fileList) {
      this.fileList = []
      this.preexchangeForm.fjzmid = ''
    },
    // 删除统计表
    handleRemoveTj(file, fileList) {
      this.fileListTj = []
      this.preexchangeForm.tjbid = ''
    },
    uploadOk(param) {},
    // 预览附件
    async previewFj(id, type, name) {
      const params = {
        fileId: id
      }
      let response
      if (type === '1') {
        response = await axios.get('/sc/ticketMain/api/factYdclZb/previewFjzmFile', {
          baseURL: process.env.VUE_APP_BASE_API,
          params: params,
          headers: {
            InternetToken: getToken()
          },
          responseType: 'blob' // 设置响应类型为二进制流
        })
      } else {
        response = await axios.get('/sc/ticketMain/api/factYdclZb/previewTjbFile', {
          baseURL: process.env.VUE_APP_BASE_API,
          params: params,
          responseType: 'blob' // 设置响应类型为二进制流
        })
      }

      const blob = new Blob([response.data], { type: response.headers['content-type'] })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = name // 下载文件的名称
      document.body.appendChild(link)
      link.click()
      URL.revokeObjectURL(url)
    },

    // 提交接口
    handleConfirm() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          getSaveOrUpdate(this.preexchangeForm).then((res) => {
            if (res.code === 200) {
              this.showDialog = false
              this.tabClick({ value: '预兑材料' })
              this.$message({
                type: 'success',
                message: '导入成功'
              })
            }
          })
        } else {
          this.fileListDr = []
          // console.log('error submit!!')
          return false
        }
      })
    },
    handleCancelForm() {
      this.$refs.ruleForm.resetFields()
      this.showDialog = false
      this.lookDisabled = false

      this.fileList = []
      this.fileListDr = []
      this.fileListTj = []

      this.preexchangeForm = {
        id: getUuid(), //主键（需要前端生成）'
        jgmc: '', //机构名称
        jgid: '', //机构id
        dfjewy: '', //兑付金额(万元
        htjewy: '', //合同金额(万元
        cjsj: '', //创建时间
        zt: '', //状态（0失效1生效）'
        fjzmid: '', //附件证明id
        tjbid: '' //统计表id
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/form.scss';
.contentBox {
  width: 100%;
  height: 100%;
  .tableBox {
    margin-top: 25px;
  }
}
.innovationVoucher {
  font-weight: bold;
  display: flex;
  font-size: 20px;
  color: #333333;
  margin-bottom: 15px;
  span {
    margin-left: 10px;
  }
  :nth-child(3) {
    font-size: 16px;
    font-weight: bold;
    color: #ff0000;
    margin-left: 15px;
  }
}
.tabs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 34px;
  .left {
    display: flex;
    :nth-child(1) {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 29px;
      padding: 5px;
      opacity: 0.75;
      background: #3f7fff;
    }
    :nth-child(2) {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      margin-left: 17px;
    }
  }
  .right {
    display: flex;
    :nth-child(1) {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 70px;
      height: 30px;
      border-radius: 5px 5px 5px 5px;
      background: #adadad;
      margin-right: 10px;
      cursor: pointer;
    }
    :nth-child(2) {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 70px;
      height: 30px;
      border-radius: 5px 5px 5px 5px;
      background: #3f7fff;
      cursor: pointer;
    }
  }
}
.table-container {
  padding: 15px;
  border: 1px solid rgb(243, 247, 255) !important;
  background: rgb(252, 252, 252);
  margin-top: 15px !important;
  margin-bottom: 0px !important;
}
// 企业兑付申请表单样式
.applyform {
  padding: 10px;
  .box-cards {
    margin-bottom: 10px;
    .card-title {
      display: flex;
      align-items: center;
      div {
        width: 5px;
        height: 13px;
        background: rgb(88, 155, 248);
        margin-right: 10px;
      }
      span {
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
}

::v-deep .el-form {
  .el-form-item {
    display: flex;
  }
  .el-form-item__content {
    margin-left: 10px !important;
    // display: flex;
  }
}

::v-deep .columngroup {
  display: flex;
  flex-direction: column;
  .el-radio {
    margin-bottom: 10px;
  }
}

::v-deep .columngroup2 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .el-radio {
    margin-bottom: 10px;
  }
}

::v-deep .columngroup3 {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  .el-radio {
    margin-bottom: 10px;
  }
}
.warnig_text {
  color: red;
  font-weight: bold;
  margin-left: 15px;
  font-size: 16px;
}

::v-deep.upload-attachments {
  .el-card__body {
    .upload-icon {
      cursor: pointer;
      font-size: 16px;
      color: rgb(86, 165, 253);
      i {
        margin-right: 5px;
      }
    }
  }
}
::v-deep .el-dialog__footer {
  display: none !important;
}
</style>
